import styled from "styled-components"

const StyledStepFirst = styled.div`
  .order-types {
    &__container {
      margin-top: 54px;
      position: relative;
    }
    &__wrapper {
      display: flex;
      justify-content: space-between;
    }
  }
  .order-type {
    cursor: pointer;
    flex-basis: calc(50% - 15px);
    max-width: calc(50% - 15px);
    input {
      display: none;
    }
    input:checked + .order-type__box,.order-type__box:hover {
      background-color: #000000;
      &::before {
        border-color: #00fb6e;
        background-color: #00fb6e;
      }
      .box-icon {
        path {
          fill: #fff;
        }
      }
      .box-text {
        p {
          color: #fff;
        }
      }
    }
    &__box {
      height: 100%;
      border: 3px solid #000000;
      position: relative;
      transition: 0.2s;
      &::before {
        content: "";
        position: absolute;
        z-index: 1;
        display: block;
        width: 25px;
        height: 25px;
        border: 3px solid #000;
        border-radius: 50%;
        top: 50%;
        left: 24px;
        transform: translateY(-50%);
        transition: 0.2s;
        background-color: #fff;
      }
      .box-row {
        display: flex;
        align-items: center;
        padding: 35px 30px 35px 108px;
        height: 100%;
        .box-icon {
          flex-basis: 110px;
          max-width: 110px;
          .box-icon {
            path {
              transition: 0.2s;
            }
          }
        }
        .box-text {
          flex: 1;
          p {
            font-size: 24px;
            line-height: 32px;
            transition: 0.2s;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px) {
    .order-type {
      &__box {
        .box-row {
          padding: 30px 30px 35px 90px;
          .box-icon {
            flex-basis: 90px;
            max-width: 90px;
          }
          .box-text {
            p {
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 950px) {
    .order-types {
      &__container {
        margin-top: 73px;
      }
      &__wrapper {
        flex-flow: wrap;
      }
    }
    .order-type {
      flex-basis: 100%;
      max-width: 100%;
      &:first-child {
        margin-bottom: 30px;
      }
    }
  }
  @media screen and (max-width: 600px) {
    .order-type {
      &__box {
        &::before {
          width: 21px;
          height: 21px;
          left: 15px;
        }
        .box-row {
          padding: 35px 15px 35px 60px;
          .box-icon {
            flex-basis: 60px;
            max-width: 60px;
            svg {
              max-width: 40px;
            }
          }
          .box-text {
            p {
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
    }
  }
`

export default StyledStepFirst
